import {
  REQUEST_ADD_REACTION, FAIL_ADD_REACTION,
  REQUEST_REMOVE_REACTION, FAIL_REMOVE_REACTION,
  ADD_CONTENT_REACTION,
  SET_REACTION_SHOULD_ANIMATE_IN, SET_REACTION_SHOULD_ANIMATE_OUT,
} from 'shared/actionTypes';

function currentUserReactions(state = [], action) {
  const { reaction } = action.payload;

  switch (action.type) {
  case REQUEST_ADD_REACTION:
  case FAIL_REMOVE_REACTION:
    return [...state, reaction];
  case REQUEST_REMOVE_REACTION:
  case FAIL_ADD_REACTION:
    const reactionIndex = state.lastIndexOf(reaction);
    if (reactionIndex === -1) {
      return state;
    }

    return [
      ...state.slice(0, reactionIndex),
      ...state.slice(reactionIndex + 1),
    ];
  default:
    return state;
  }
}

function existingReactions(state = [], action, newReactions) {
  const { reaction } = action.payload;
  const { count = 0 } = newReactions[reaction];

  const reactionIndex = state.lastIndexOf(reaction);
  const reactionExists = (reactionIndex !== -1);

  switch (action.type) {
  case REQUEST_ADD_REACTION:
  case FAIL_REMOVE_REACTION:
    if (count < 1 || reactionExists) {
      return state;
    }

    return [reaction, ...state];
  case REQUEST_REMOVE_REACTION:
  case FAIL_ADD_REACTION:
    if (count > 0 || !reactionExists) {
      return state;
    }

    return [
      ...state.slice(0, reactionIndex),
      ...state.slice(reactionIndex + 1),
    ];
  default:
    return state;
  }
}

function reactions(state = {}, action) {
  const { reaction } = action.payload;
  const {
    count = 0,
    shouldAnimateIn = false,
    shouldAnimateOut = false,
  } = state[reaction] || {};

  switch (action.type) {
  case REQUEST_ADD_REACTION:
  case FAIL_REMOVE_REACTION:
    return Object.assign({}, state, {
      [reaction]: {
        count: (count + 1),
        shouldAnimateIn,
        shouldAnimateOut,
      },
    });
  case REQUEST_REMOVE_REACTION:
  case FAIL_ADD_REACTION:
    return Object.assign({}, state, {
      [reaction]: {
        count: Math.max(0, (count - 1)),
        shouldAnimateIn,
        shouldAnimateOut,
      },
    });
  case SET_REACTION_SHOULD_ANIMATE_IN:
    const { shouldAnimateIn: nextShouldAnimateIn } = action.payload;
    return Object.assign({}, state, {
      [reaction]: {
        count,
        shouldAnimateIn: nextShouldAnimateIn,
        shouldAnimateOut,
      },
    });
  case SET_REACTION_SHOULD_ANIMATE_OUT:
    const { shouldAnimateOut: nextShouldAnimateOut } = action.payload;
    return Object.assign({}, state, {
      [reaction]: {
        count,
        shouldAnimateIn,
        shouldAnimateOut: nextShouldAnimateOut,
      },
    });
  default:
    return state;
  }
}

function addContentReaction(state, action) {
  const {
    communityContentType,
    communityContentRelatedId,
    contentReaction,
  } = action.payload;
  const communityContentIdKey = `${communityContentType}-${communityContentRelatedId}`;
  return Object.assign({}, state, {
    [communityContentIdKey]: Object.assign({}, contentReaction),
  });
}

function updateContentReactions(state, action) {
  const { communityContentType, communityContentRelatedId } = action.payload;
  const communityContentIdKey = `${communityContentType}-${communityContentRelatedId}`;
  const {
    reactions: oldReactions = {},
    currentUserReactions: oldCurrentUserReactions = [],
    existingReactions: oldExistingReactions = [],
    reactionMessageParts: oldReactionMessageParts = [],
    reactionMessagePartsAlternate: oldReactionMessagePartsAlternate = [],
  } = state[communityContentIdKey] || {};

  const newReactions = reactions(oldReactions, action);

  // If user removes all of his/her reactions from feedcard swap
  // or if the user adds his/her first reaction to the feedcard,
  // swap the reaction details message
  if ((action.type === REQUEST_REMOVE_REACTION && oldCurrentUserReactions.length === 1)
      || action.type === REQUEST_ADD_REACTION && oldCurrentUserReactions.length === 0
      || action.type === FAIL_REMOVE_REACTION && oldCurrentUserReactions.length === 0
      || action.type === FAIL_ADD_REACTION && oldCurrentUserReactions.length === 1) {
    return Object.assign({}, state, {
      [communityContentIdKey]: {
        reactions: newReactions,
        currentUserReactions: currentUserReactions(oldCurrentUserReactions, action),
        existingReactions: existingReactions(oldExistingReactions, action, newReactions),
        reactionMessageParts: oldReactionMessagePartsAlternate,
        reactionMessagePartsAlternate: oldReactionMessageParts,
      },
    });
  }

  return Object.assign({}, state, {
    [communityContentIdKey]: {
      reactions: newReactions,
      currentUserReactions: currentUserReactions(oldCurrentUserReactions, action),
      existingReactions: existingReactions(oldExistingReactions, action, newReactions),
      reactionMessageParts: oldReactionMessageParts,
      reactionMessagePartsAlternate: oldReactionMessagePartsAlternate,
    },
  });
}

export default function contentReactions(state = {}, action) {
  switch (action.type) {
  case ADD_CONTENT_REACTION:
    return addContentReaction(state, action);
  case REQUEST_ADD_REACTION:
  case FAIL_ADD_REACTION:
  case REQUEST_REMOVE_REACTION:
  case FAIL_REMOVE_REACTION:
  case SET_REACTION_SHOULD_ANIMATE_IN:
  case SET_REACTION_SHOULD_ANIMATE_OUT:
    return updateContentReactions(state, action);
  default:
    return state;
  }
}
